import React from 'react';

import PropTypes from 'prop-types';
import { MdWarning } from 'react-icons/md';

import { Tooltip } from '@shared';
import { intl } from '@shared/localization';

import { historyItemsTypes } from '../../../constants';
import styles from './HistoryItemStatus.less';

const HistoryItemStatus = ({ type, status, isSynced }) => {
  if (type == historyItemsTypes.ADVANCEMENT_FILE) {
    return <span>{status}</span>;
  }
  return (
    <div className={styles.wrapper}>
      {!isSynced && (
        <Tooltip
          title={intl.formatMessage({
            id: 'advancementHistory.HistoryItemStatus.unSyncedFile',
          })}
        >
          <MdWarning className={styles.warning} />
        </Tooltip>
      )}
      {status}
    </div>
  );
};

HistoryItemStatus.getUnSyncedFileMessage = () =>
  intl.formatMessage({
    id: 'advancementHistory.HistoryItemStatus.unSyncedFile',
  });

HistoryItemStatus.propTypes = {
  type: PropTypes.oneOf([
    historyItemsTypes.ADVANCEMENT,
    historyItemsTypes.ADVANCEMENT_FILE,
    historyItemsTypes.ACTIVITY,
  ]).isRequired,
  status: PropTypes.string,
  isSynced: PropTypes.bool,
};

export default HistoryItemStatus;
